import { render, staticRenderFns } from "./DynamicInput.vue?vue&type=template&id=813e6810&"
import script from "./DynamicInput.vue?vue&type=script&lang=ts&"
export * from "./DynamicInput.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicInput.vue?vue&type=style&index=0&id=813e6810&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports